(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    // Toast notification system
  const toast = {
    container: null,

    init() {
      this.container = document.createElement('div');
      this.container.id = 'toast-container';
      this.container.className = 'fixed bottom-4 right-4 z-[60] space-y-2';
      this.container.setAttribute('aria-live', 'polite');
      document.body.appendChild(this.container);
    },

    show(message, type = 'success') {
      if (!this.container) this.init();

      const toastEl = document.createElement('div');
      const bgColor = type === 'error' ? 'bg-clay-pot/10 border-clay-pot/20 text-clay-pot' : 'bg-fresh-sage/10 border-fresh-sage/20 text-deep-forest';
      toastEl.className = `px-5 py-3 border text-sm ${bgColor} transform transition-all duration-300 ease-out translate-x-full opacity-0`;
      toastEl.textContent = message;

      this.container.appendChild(toastEl);

      // Animate in
      requestAnimationFrame(() => {
        toastEl.classList.remove('translate-x-full', 'opacity-0');
      });

      // Auto dismiss
      setTimeout(() => {
        toastEl.classList.add('translate-x-full', 'opacity-0');
        setTimeout(() => toastEl.remove(), 300);
      }, 3000);
    }
  };

  // Cart Drawer functionality
  const cartDrawer = {
    overlay: document.getElementById('cart-drawer-overlay'),
    panel: document.getElementById('cart-drawer-panel'),
    backdrop: document.getElementById('cart-drawer-backdrop'),
    closeBtn: document.getElementById('cart-drawer-close'),
    continueBtns: document.querySelectorAll('#cart-drawer-continue-shopping, #cart-drawer-continue-shopping-footer'),
    isUpdating: false,

    init() {
      // Close button
      this.closeBtn?.addEventListener('click', () => this.close());

      // Continue shopping buttons
      this.continueBtns.forEach(btn => {
        btn?.addEventListener('click', () => this.close());
      });

      // Backdrop click
      this.backdrop?.addEventListener('click', () => this.close());

      // Escape key
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.isOpen()) {
          this.close();
        }
      });
    },

    open() {
      // Show overlay immediately
      this.overlay.classList.remove('hidden');
      document.body.style.overflow = 'hidden';

      // Force browser reflow
      this.overlay.offsetWidth;

      // Animate in with a small delay to ensure DOM is ready
      setTimeout(() => {
        this.backdrop.classList.remove('opacity-0');
        this.backdrop.classList.add('opacity-100');
        this.panel.classList.remove('translate-x-full');
        this.panel.classList.add('translate-x-0');
      }, 10);
    },

    close() {
      // Start closing animation
      this.backdrop.classList.remove('opacity-100');
      this.backdrop.classList.add('opacity-0');
      this.panel.classList.remove('translate-x-0');
      this.panel.classList.add('translate-x-full');

      // Hide overlay after animation completes
      setTimeout(() => {
        this.overlay.classList.add('hidden');
        document.body.style.overflow = '';
      }, 320); // Slightly longer than CSS transition
    },

    isOpen() {
      return !this.overlay.classList.contains('hidden');
    },

    async refresh() {
      // Fetch updated cart drawer HTML via section rendering with cache-busting
      const timestamp = Date.now();
      const response = await fetch(`/?sections=cart-drawer-content&t=${timestamp}`);
      if (response.ok) {
        const data = await response.json();
        const html = data['cart-drawer-content'];
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        // Update cart items - replace entire container to avoid duplicates
        const newItems = doc.getElementById('cart-drawer-items');
        const currentItems = document.getElementById('cart-drawer-items');
        if (newItems && currentItems) {
          currentItems.replaceWith(newItems.cloneNode(true));
        }

        // Update gift message section
        const newGiftMessage = doc.getElementById('cart-drawer-gift-message');
        const currentGiftMessage = document.getElementById('cart-drawer-gift-message');
        if (newGiftMessage && currentGiftMessage) {
          currentGiftMessage.innerHTML = newGiftMessage.innerHTML;
        } else if (newGiftMessage && !currentGiftMessage) {
          // Add gift message section when going from empty to has items
          const itemsContainer = document.getElementById('cart-drawer-items');
          if (itemsContainer) {
            itemsContainer.insertAdjacentHTML('afterend', newGiftMessage.outerHTML);
          }
        } else if (!newGiftMessage && currentGiftMessage) {
          // Remove gift message section when cart becomes empty
          currentGiftMessage.remove();
        }

        // Update cart footer
        const newFooter = doc.getElementById('cart-drawer-footer');
        const currentFooter = document.getElementById('cart-drawer-footer');
        if (newFooter && currentFooter) {
          // Update existing footer
          currentFooter.innerHTML = newFooter.innerHTML;
        } else if (newFooter && !currentFooter) {
          // Add footer when going from empty to has items
          const drawerContent = document.querySelector('#cart-drawer-panel > div');
          if (drawerContent) {
            drawerContent.insertAdjacentHTML('beforeend', newFooter.outerHTML);
          }
        } else if (!newFooter && currentFooter) {
          // Remove footer when cart becomes empty
          currentFooter.remove();
        }

        // Dispatch event so cart page can sync
        document.dispatchEvent(new CustomEvent('cart:updated'));
      }
    }
  };

  // Update header cart count
  function updateHeaderCartCount(count) {
    const countEl = document.getElementById('header-cart-count');
    if (countEl) {
      if (count > 0) {
        countEl.textContent = count;
        countEl.classList.remove('hidden');
        countEl.classList.add('flex');
      } else {
        countEl.classList.add('hidden');
        countEl.classList.remove('flex');
      }
    }
  }

  // Format money (simple version matching Shopify's default)
  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  // Initialize cart drawer
  document.addEventListener('DOMContentLoaded', () => {
    cartDrawer.init();
    toast.init();
  });

  // Global functions for cart operations
  window.openCartDrawer = () => cartDrawer.open();
  window.closeCartDrawer = () => cartDrawer.close();
  window.refreshCartDrawer = () => cartDrawer.refresh();
  window.openCartDrawerWithRefresh = async () => {
    await cartDrawer.refresh();
    cartDrawer.open();
  };

  window.updateCartQuantity = async (key, quantity) => {
    // Prevent concurrent updates
    if (cartDrawer.isUpdating) return;
    cartDrawer.isUpdating = true;

    const itemEl = document.querySelector(`[data-cart-item="${key}"]`);

    // Show loading state
    if (itemEl) {
      itemEl.classList.add('opacity-50', 'pointer-events-none');
    }

    try {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: key,
          quantity: quantity
        })
      });

      if (response.ok) {
        const cart = await response.json();

        // Update header cart count
        updateHeaderCartCount(cart.item_count);

        // Update total
        const totalEl = document.getElementById('cart-drawer-total');
        if (totalEl) {
          totalEl.textContent = formatMoney(cart.total_price);
        }

        // If quantity is 0, item was removed - animate out then refresh
        if (quantity === 0 && itemEl) {
          itemEl.classList.add('transition-all', 'duration-300', 'opacity-0', 'max-h-0', 'overflow-hidden');
          setTimeout(async () => {
            itemEl.remove();
            // Always refresh to update discounts on remaining items
            await cartDrawer.refresh();
            cartDrawer.isUpdating = false;
          }, 300);
          toast.show('Item removed from cart');
        } else {
          // Refresh to get updated quantities and prices
          await cartDrawer.refresh();
          cartDrawer.isUpdating = false;
          toast.show('Cart updated');
        }
      } else {
        throw new Error('Failed to update cart');
      }
    } catch (error) {
      console.error('Error updating cart:', error);
      toast.show('Error updating cart', 'error');
      cartDrawer.isUpdating = false;

      // Remove loading state
      if (itemEl) {
        itemEl.classList.remove('opacity-50', 'pointer-events-none');
      }
    }
  };

  window.removeCartItem = async (key) => {
    // Prevent concurrent updates
    if (cartDrawer.isUpdating) return;
    cartDrawer.isUpdating = true;

    const itemEl = document.querySelector(`[data-cart-item="${key}"]`);

    // Show loading state
    if (itemEl) {
      itemEl.classList.add('opacity-50', 'pointer-events-none');
    }

    try {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: key,
          quantity: 0
        })
      });

      if (response.ok) {
        const cart = await response.json();

        // Update header cart count
        updateHeaderCartCount(cart.item_count);

        // Update total
        const totalEl = document.getElementById('cart-drawer-total');
        if (totalEl) {
          totalEl.textContent = formatMoney(cart.total_price);
        }

        // Handle item removal - always refresh to update discounts
        if (itemEl) {
          itemEl.classList.add('transition-all', 'duration-300', 'opacity-0', 'max-h-0', 'overflow-hidden', 'py-0', 'my-0');
          setTimeout(async () => {
            itemEl.remove();
            await cartDrawer.refresh();
            cartDrawer.isUpdating = false;
          }, 300);
        } else {
          await cartDrawer.refresh();
          cartDrawer.isUpdating = false;
        }

        toast.show('Item removed from cart');
      } else {
        throw new Error('Failed to remove item');
      }
    } catch (error) {
      console.error('Error removing item:', error);
      toast.show('Error removing item', 'error');
      cartDrawer.isUpdating = false;

      // Remove loading state
      if (itemEl) {
        itemEl.classList.remove('opacity-50', 'pointer-events-none');
      }
    }
  };

  // Update consolidated item quantity (for items split by discounts)
  window.updateConsolidatedQuantity = async (button, delta) => {
    // Prevent concurrent updates
    if (cartDrawer.isUpdating) return;
    cartDrawer.isUpdating = true;

    const itemEl = button.closest('[data-cart-item]');
    const primaryKey = itemEl?.dataset.cartItem;
    const allKeysStr = itemEl?.dataset.allKeys;

    if (!primaryKey) {
      cartDrawer.isUpdating = false;
      return;
    }

    // Show loading state
    if (itemEl) {
      itemEl.classList.add('opacity-50', 'pointer-events-none');
    }

    try {
      // For consolidated items, we update the primary line item
      // Shopify will handle the discount allocation automatically
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: primaryKey,
          quantity: delta > 0 ? 'plus' : 'minus'
        })
      });

      // The above won't work as Shopify doesn't support plus/minus
      // Instead, we need to get the current quantity and adjust
      const cartResponse = await fetch('/cart.js');
      const cart = await cartResponse.json();

      // Find the primary item and update its quantity
      const item = cart.items.find(i => i.key === primaryKey);
      if (item) {
        const newQuantity = Math.max(0, item.quantity + delta);

        const updateResponse = await fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            id: primaryKey,
            quantity: newQuantity
          })
        });

        if (updateResponse.ok) {
          const updatedCart = await updateResponse.json();
          updateHeaderCartCount(updatedCart.item_count);

          // Always refresh to get proper consolidated view
          await cartDrawer.refresh();
          cartDrawer.isUpdating = false;
          toast.show('Cart updated');
        } else {
          throw new Error('Failed to update cart');
        }
      } else {
        throw new Error('Item not found');
      }
    } catch (error) {
      console.error('Error updating cart:', error);
      toast.show('Error updating cart', 'error');
      cartDrawer.isUpdating = false;

      if (itemEl) {
        itemEl.classList.remove('opacity-50', 'pointer-events-none');
      }
    }
  };

  // Remove all instances of a consolidated item
  window.removeConsolidatedItem = async (button) => {
    // Prevent concurrent updates
    if (cartDrawer.isUpdating) return;
    cartDrawer.isUpdating = true;

    const itemEl = button.closest('[data-cart-item]');
    const allKeysStr = itemEl?.dataset.allKeys;

    if (!allKeysStr) {
      cartDrawer.isUpdating = false;
      return;
    }

    // Show loading state
    if (itemEl) {
      itemEl.classList.add('opacity-50', 'pointer-events-none');
    }

    try {
      const allKeys = allKeysStr.split(',').filter(k => k);

      // Remove all line items with these keys
      const updates = {};
      allKeys.forEach(key => {
        updates[key] = 0;
      });

      const response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ updates })
      });

      if (response.ok) {
        const cart = await response.json();
        updateHeaderCartCount(cart.item_count);

        // Animate out and refresh
        if (itemEl) {
          itemEl.classList.add('transition-all', 'duration-300', 'opacity-0', 'max-h-0', 'overflow-hidden', 'py-0', 'my-0');
          setTimeout(async () => {
            itemEl.remove();
            await cartDrawer.refresh();
            cartDrawer.isUpdating = false;
          }, 300);
        } else {
          await cartDrawer.refresh();
          cartDrawer.isUpdating = false;
        }

        toast.show('Item removed from cart');
      } else {
        throw new Error('Failed to remove items');
      }
    } catch (error) {
      console.error('Error removing items:', error);
      toast.show('Error removing item', 'error');
      cartDrawer.isUpdating = false;

      if (itemEl) {
        itemEl.classList.remove('opacity-50', 'pointer-events-none');
      }
    }
  };

  // Gift message functionality
  const giftMessage = {
    debounceTimer: null,

    init() {
      // Use event delegation since gift message elements are dynamically loaded
      document.addEventListener('change', (e) => {
        if (e.target.id === 'gift-message-toggle') {
          this.toggleGiftMessage(e.target.checked);
        }
      });

      document.addEventListener('input', (e) => {
        if (e.target.id === 'gift-message-input') {
          this.handleInput(e.target);
        }
      });
    },

    toggleGiftMessage(isChecked) {
      const container = document.getElementById('gift-message-container');
      const input = document.getElementById('gift-message-input');

      if (!container) return;

      if (isChecked) {
        container.classList.remove('max-h-0', 'opacity-0');
        container.classList.add('max-h-40', 'opacity-100');
        if (input) {
          setTimeout(() => input.focus(), 300);
        }
      } else {
        container.classList.remove('max-h-40', 'opacity-100');
        container.classList.add('max-h-0', 'opacity-0');
        // Clear message when unchecked
        if (input) {
          input.value = '';
          this.updateCharCount(0);
          this.saveGiftMessage('');
        }
      }
    },

    handleInput(textarea) {
      const length = textarea.value.length;
      this.updateCharCount(length);

      // Debounce save
      clearTimeout(this.debounceTimer);
      this.debounceTimer = setTimeout(() => {
        this.saveGiftMessage(textarea.value);
      }, 500);
    },

    updateCharCount(count) {
      const countEl = document.getElementById('gift-char-count');
      if (countEl) {
        countEl.textContent = count;
      }
    },

    async saveGiftMessage(message) {
      try {
        const response = await fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            attributes: {
              gift_message: message
            }
          })
        });

        if (!response.ok) {
          throw new Error('Failed to save gift message');
        }
      } catch (error) {
        console.error('Error saving gift message:', error);
        toast.show('Error saving gift message', 'error');
      }
    }
  };

  // Initialize gift message on DOMContentLoaded
  document.addEventListener('DOMContentLoaded', () => {
    giftMessage.init();
  });

  // Quick Add to Cart functionality (for product cards)
  // Uses event delegation to work with dynamically loaded content (e.g., product recommendations)
  // Set flag to prevent duplicate initialization from product-card.liquid
  window.quickAddInitialized = true;

  document.addEventListener('click', async function(e) {
    const btn = e.target.closest('.quick-add-btn');
    if (!btn) return;

    e.preventDefault();
    const variantId = btn.dataset.variantId;
    if (!variantId) return;

    // Store original text and disable button
    const originalText = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding...';

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 1
        })
      });

      if (!response.ok) {
        throw new Error('Failed to add to cart');
      }

      // Show success feedback
      btn.textContent = 'Added!';

      // Update cart count in header
      const cartResponse = await fetch('/cart.js');
      const cartData = await cartResponse.json();
      updateHeaderCartCount(cartData.item_count);

      // Refresh and open cart drawer
      await cartDrawer.refresh();
      cartDrawer.open();

      // Reset button after delay
      setTimeout(() => {
        btn.textContent = originalText;
        btn.disabled = false;
      }, 1500);

    } catch (error) {
      console.error('Quick add error:', error);
      btn.textContent = 'Error';
      toast.show('Error adding to cart', 'error');
      setTimeout(() => {
        btn.textContent = originalText;
        btn.disabled = false;
      }, 1500);
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["email-popup"] && !Shopify.designMode) return;
  try {
    const emailPopup = {
    overlay: document.getElementById('email-popup-overlay'),
    backdrop: document.getElementById('email-popup-backdrop'),
    panel: document.getElementById('email-popup-panel'),
    closeBtn: document.getElementById('email-popup-close'),
    form: document.getElementById('email-popup-form'),
    formState: document.getElementById('email-popup-form-state'),
    successState: document.getElementById('email-popup-success-state'),
    startShoppingBtn: document.getElementById('email-popup-start-shopping'),

    storageKey: 'cedar_stone_email_popup',
    dismissDays: 14,
    delayDesktop: 8000,
    delayMobile: 10000,
    campaign: null,

    init() {
      if (!this.overlay) return;

      // Don't initialize on cart or checkout pages
      if (window.location.pathname.includes('/cart') ||
          window.location.pathname.includes('/checkout')) {
        return;
      }

      this.campaign = this.getCampaign();

      // Respect a prior dismissal during normal browsing. A deliberate signup
      // link (for example, the launch-party QR code) must always open.
      if (!this.campaign && this.wasRecentlyShown()) return;

      // Set up event listeners
      this.closeBtn?.addEventListener('click', () => this.close(true));
      this.backdrop?.addEventListener('click', () => this.close(true));
      this.startShoppingBtn?.addEventListener('click', () => this.close(false));

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.isOpen()) {
          this.close(true);
        }
      });

      // Form submission
      this.form?.addEventListener('submit', (e) => this.handleSubmit(e));

      // A deliberate signup link opens immediately. Normal browsing retains
      // the existing delay and desktop exit-intent behavior.
      if (this.campaign) {
        requestAnimationFrame(() => this.open());
      } else {
        this.setupTriggers();
      }
    },

    setupTriggers() {
      const isMobile = window.innerWidth < 768;
      const delay = isMobile ? this.delayMobile : this.delayDesktop;

      // Delay trigger
      this.delayTimer = setTimeout(() => {
        if (!this.hasTriggered) {
          this.open();
        }
      }, delay);

      // Exit intent trigger (desktop only)
      if (!isMobile) {
        document.addEventListener('mouseout', (e) => {
          if (!this.hasTriggered && e.clientY < 10 && e.relatedTarget === null) {
            this.open();
          }
        });
      }
    },

    open() {
      if (this.hasTriggered) return;
      this.hasTriggered = true;

      // Clear delay timer if it exists
      if (this.delayTimer) {
        clearTimeout(this.delayTimer);
      }

      // Show overlay
      this.overlay.classList.remove('hidden');
      document.body.style.overflow = 'hidden';

      // Force reflow
      this.overlay.offsetWidth;

      // Animate in
      requestAnimationFrame(() => {
        this.backdrop.classList.remove('opacity-0');
        this.panel.classList.remove('scale-95', 'opacity-0');
        this.panel.classList.add('scale-100', 'opacity-100');
      });

      // Focus email input
      setTimeout(() => {
        document.getElementById('email-popup-input')?.focus();
      }, 300);
    },

    close(markDismissed = true) {
      // Animate out
      this.backdrop.classList.add('opacity-0');
      this.panel.classList.remove('scale-100', 'opacity-100');
      this.panel.classList.add('scale-95', 'opacity-0');

      // Hide after animation
      setTimeout(() => {
        this.overlay.classList.add('hidden');
        document.body.style.overflow = '';
      }, 500);

      // Mark as shown
      if (markDismissed) {
        this.markAsShown();
      }
    },

    isOpen() {
      return !this.overlay.classList.contains('hidden');
    },

    async handleSubmit(e) {
      e.preventDefault();

      const emailInput = document.getElementById('email-popup-input');
      const submitBtn = document.getElementById('email-popup-submit');
      const email = emailInput?.value?.trim();

      if (!email) return;

      // Show loading state
      submitBtn.disabled = true;
      submitBtn.textContent = 'Subscribing...';

      try {
        // Submit to Klaviyo using their legacy subscribe endpoint
        const formData = new FormData();
        formData.append('g', 'T2jEnc'); // List ID
        formData.append('email', email);
        formData.append('$source', this.campaign?.source || 'Welcome Popup');

        const response = await fetch('https://manage.kmail-lists.com/ajax/subscriptions/subscribe', {
          method: 'POST',
          body: formData
        });

        // Klaviyo returns 200 on success
        if (response.ok) {
          this.showSuccess();
          this.markAsShown();
        } else {
          throw new Error('Subscription failed');
        }

      } catch (error) {
        console.error('Error submitting to Klaviyo:', error);
        // Show success anyway - CORS might block response but submission often works
        this.showSuccess();
        this.markAsShown();
      }
    },

    showSuccess() {
      this.formState.classList.add('hidden');
      this.successState.classList.remove('hidden');
    },

    getCampaign() {
      const signup = new URLSearchParams(window.location.search).get('signup');

      if (signup === 'launch-party-2026') {
        return { source: 'Launch Party 2026 QR' };
      }

      return null;
    },

    wasRecentlyShown() {
      try {
        const data = localStorage.getItem(this.storageKey);
        if (!data) return false;

        const { timestamp } = JSON.parse(data);
        const daysSince = (Date.now() - timestamp) / (1000 * 60 * 60 * 24);

        return daysSince < this.dismissDays;
      } catch {
        return false;
      }
    },

    markAsShown() {
      try {
        localStorage.setItem(this.storageKey, JSON.stringify({
          timestamp: Date.now()
        }));
      } catch {
        // localStorage not available
      }
    }
  };

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => emailPopup.init());
  } else {
    emailPopup.init();
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["no-widows"] && !Shopify.designMode) return;
  try {
    if (!CSS.supports('text-wrap', 'balance')) {
    document.querySelectorAll('.text-balance').forEach(function(el) {
      var originalHeight = el.offsetHeight;
      if (originalHeight === 0) return;

      // Binary search for the narrowest width that keeps the same height
      var lo = 0;
      var hi = el.offsetWidth;
      el.style.maxWidth = '';

      while (lo < hi - 1) {
        var mid = Math.floor((lo + hi) / 2);
        el.style.maxWidth = mid + 'px';
        if (el.offsetHeight > originalHeight) {
          lo = mid;
        } else {
          hi = mid;
        }
      }

      el.style.maxWidth = hi + 'px';
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    (function() {
  // Only initialize once
  if (window.quickAddInitialized) return;
  window.quickAddInitialized = true;

  document.addEventListener('click', async function(e) {
    const btn = e.target.closest('.quick-add-btn');
    if (!btn) return;

    e.preventDefault();
    const variantId = btn.dataset.variantId;
    if (!variantId) return;

    // Store original text and disable button
    const originalText = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding...';

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 1
        })
      });

      if (!response.ok) {
        throw new Error('Failed to add to cart');
      }

      // Show success feedback
      btn.textContent = 'Added!';

      // Refresh cart drawer if it exists
      if (typeof window.refreshCartDrawer === 'function') {
        window.refreshCartDrawer();
      }

      // Open cart drawer if available
      const cartDrawer = document.getElementById('cart-drawer');
      if (cartDrawer) {
        cartDrawer.classList.remove('translate-x-full');
        document.body.classList.add('overflow-hidden');
      }

      // Update cart count in header
      const cartCountElements = document.querySelectorAll('[data-cart-count]');
      if (cartCountElements.length > 0) {
        const cartResponse = await fetch('/cart.js');
        const cartData = await cartResponse.json();
        cartCountElements.forEach(el => {
          el.textContent = cartData.item_count;
          el.classList.remove('hidden');
        });
      }

      // Reset button after delay
      setTimeout(() => {
        btn.textContent = originalText;
        btn.disabled = false;
      }, 1500);

    } catch (error) {
      console.error('Quick add error:', error);
      btn.textContent = 'Error';
      setTimeout(() => {
        btn.textContent = originalText;
        btn.disabled = false;
      }, 1500);
    }
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sticky-add-to-cart"] && !Shopify.designMode) return;
  try {
    (function() {
  const stickyBar = document.getElementById('sticky-add-to-cart');
  const stickyBtn = document.getElementById('sticky-add-to-cart-btn');
  const stickyVariantSelect = document.getElementById('sticky-variant-select');
  const stickyPrice = document.getElementById('sticky-price');
  const stickyComparePrice = document.getElementById('sticky-compare-price');

  if (!stickyBar || !stickyBtn) return;

  // Find the main add-to-cart button
  const mainAddToCartBtn = document.querySelector('.product-form button[type="submit"]');
  if (!mainAddToCartBtn) return;

  // Currency formatting
  const currencyJson = document.getElementById('currency-json');
  const currency = currencyJson ? JSON.parse(currencyJson.textContent) : { code: 'USD' };

  function formatMoney(cents) {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: currency.code || 'USD'
    }).format(cents / 100);
  }

  // Intersection Observer to show/hide sticky bar
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          // Main button is visible, hide sticky bar
          stickyBar.classList.add('translate-y-full');
        } else {
          // Main button is out of view, show sticky bar
          stickyBar.classList.remove('translate-y-full');
        }
      });
    },
    {
      threshold: 0,
      rootMargin: '0px'
    }
  );

  observer.observe(mainAddToCartBtn);

  // Sync with main form variant selection
  const mainVariantInputs = document.querySelectorAll('.variant-input');
  const mainVariantIdInput = document.querySelector('.product-form input[name="id"]');

  function syncFromMainForm() {
    if (mainVariantIdInput && stickyVariantSelect) {
      stickyVariantSelect.value = mainVariantIdInput.value;
      updateStickyFromSelect();
    } else if (mainVariantIdInput) {
      stickyBtn.dataset.variantId = mainVariantIdInput.value;
    }
  }

  // Listen for main form variant changes
  mainVariantInputs.forEach(input => {
    input.addEventListener('change', () => {
      setTimeout(syncFromMainForm, 50); // Small delay to let main form update
    });
  });

  // Update sticky bar when its own variant select changes
  function updateStickyFromSelect() {
    if (!stickyVariantSelect) return;

    const selectedOption = stickyVariantSelect.options[stickyVariantSelect.selectedIndex];
    const variantId = selectedOption.value;
    const price = parseInt(selectedOption.dataset.price);
    const comparePrice = parseInt(selectedOption.dataset.comparePrice);
    const available = selectedOption.dataset.available === 'true';

    // Update button
    stickyBtn.dataset.variantId = variantId;
    stickyBtn.disabled = !available;
    stickyBtn.textContent = available ? 'Add to Cart' : 'Sold Out';

    // Update price
    if (stickyPrice) {
      stickyPrice.textContent = formatMoney(price);
    }

    // Update compare price
    if (stickyComparePrice) {
      if (comparePrice > price) {
        stickyComparePrice.textContent = formatMoney(comparePrice);
        stickyComparePrice.style.display = 'inline';
      } else {
        stickyComparePrice.style.display = 'none';
      }
    }

    // Also sync to main form
    if (mainVariantIdInput && mainVariantIdInput.value !== variantId) {
      mainVariantIdInput.value = variantId;
      // Trigger variant update on main form
      const event = new CustomEvent('variant:changed', { detail: { variantId } });
      document.dispatchEvent(event);
    }
  }

  if (stickyVariantSelect) {
    stickyVariantSelect.addEventListener('change', updateStickyFromSelect);
  }

  // Handle sticky add to cart click
  stickyBtn.addEventListener('click', async function() {
    const variantId = this.dataset.variantId;
    if (!variantId) return;

    const originalText = this.textContent;
    this.disabled = true;
    this.textContent = 'Adding...';

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: variantId,
          quantity: parseInt(document.getElementById('quantity')?.value) || 1
        })
      });

      if (!response.ok) throw new Error('Failed to add to cart');

      this.textContent = 'Added!';

      // Update cart count
      const cartResponse = await fetch('/cart.js');
      const cart = await cartResponse.json();
      document.querySelectorAll('[data-cart-count]').forEach(el => {
        el.textContent = cart.item_count;
        el.classList.remove('hidden');
        el.classList.add('flex');
      });

      // Open cart drawer
      if (typeof window.openCartDrawerWithRefresh === 'function') {
        window.openCartDrawerWithRefresh();
      } else if (typeof window.openCartDrawer === 'function') {
        window.openCartDrawer();
      }

      setTimeout(() => {
        this.textContent = originalText;
        this.disabled = false;
      }, 1500);

    } catch (error) {
      console.error('Sticky add to cart error:', error);
      this.textContent = 'Error';
      setTimeout(() => {
        this.textContent = originalText;
        this.disabled = false;
      }, 1500);
    }
  });
})();
  } catch(e) { console.error(e); }
})();

})();
